<div class="d-flex flex-row-fluid w-100 header-wrapper"
     [style.background-image]="('url(' + headerUrl + ')')"
     style="height: 400px; background-size: cover; background-position: left 27%; border-radius: .4rem">
  <div class="d-flex align-items-center text-center flex-column justify-content-center h-100 w-100">
    <sb-card classes="green-border">
      <div card-body>
        <div class="d-flex justify-content-between text-start">
          <div style="position: absolute;top: -67px;display: flex;">
            <div class="image-video-wrapper">
              <div class="userPic" [style.backgroundImage]="avatarUrl?'url('+avatarUrl+')':''">
              </div>
            </div>
            <div class="ml-4">
              <h2 style="color: #fdfeff;text-shadow: 0 0 10px #000;"
                  class="font-weight-bolder">{{inventoryElement?.name ? inventoryElement?.name : inventoryElement?.identifier}}</h2>
              <h6
                style="color: #fdfeff;text-shadow: 0 0 5px #000;">{{'lang.globals.locationID:' | translate}} {{inventoryElement?.id}}</h6>
            </div>
          </div>

          <div style="padding-left: 10rem" class="d-flex flex-row">
            <sb-aggregation-report [aggregatedData]="inventoryData.report" [showCaption]="false"></sb-aggregation-report>
          </div>
        </div>


      </div>
    </sb-card>
  </div>
</div>
<div style="padding: 0 10rem; margin-top: -100px">
  <div class="row">
    <div class="col-4">
      <sb-card>
        <div card-body classes="d-flex align-items-center flex-grow-1 w-100" class="flex-grow-1 w-100">
          <div class="d-flex align-items-center w-100 ">
            <div>
              <h4>{{inventoryElement?.name ? inventoryElement?.name : inventoryElement?.identifier}}</h4>
              <h6>{{'lang.globals.locationId' | translate}}: {{inventoryElement?.id}}</h6>
            </div>
          </div>
          <div class="mt-4">
            <h5 class="mb-2">{{'lang.address.information:' | translate}}</h5>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="text-dark-75 font-weight-bolder">{{'lang.globals.street:' | translate}}</span><span
              class="text-muted"> {{inventoryElement?.address?.street}} {{inventoryElement?.address?.street2}}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="text-dark-75 font-weight-bolder">{{'lang.globals.zip:' | translate}}
                / {{'lang.locationInventoryDetailsComponent.city:' | translate}}</span><span
              class="text-muted"> {{inventoryElement?.address?.zip}}  {{inventoryElement?.address?.city}}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="text-dark-75 font-weight-bolder">{{'lang.globals.state:' | translate}}</span><span
              class="text-muted"> {{inventoryElement?.address?.state}}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="text-dark-75 font-weight-bolder">{{'lang.globals.country:' | translate}}</span><span
              class="text-muted"> {{inventoryElement?.address?.country}}</span>
            </div>
          </div>
          <div class="mt-4">
            <h5 class="mb-2">{{'lang.globals.openingHours:' | translate}}</h5>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="text-dark-75 font-weight-bolder">{{'lang.globals.nA' | translate}}</span>
            </div>
          </div>
        </div>
      </sb-card>
    </div>
    <div class="col-8" style="height: 530px">
      <sb-card>
        <div classes="no-border" card-header>
          <h3
            [innerHTML]="inventoryElement?.identifier ? inventoryElement?.identifier : inventoryElement?.name | truncate : 20"></h3>
        </div>
        <div card-body>
          <sb-map [roundedCorners]="true" [drawing]="false" [mapHeight]="400"
                  [showSinglePoint]="getSelectedLocationCoords()"></sb-map>
        </div>
      </sb-card>
    </div>
  </div>
</div>
